import React from 'react';
import { Container } from '@common/components/container';
import { TopNavigationBar } from '@common/components/navigation-bar';
import { useTranslation } from 'react-i18next';
import { Route, useRouteMatch } from 'react-router';
import { Switch } from '@common/components/router';
import PerformanceRatingContainer from './performance-ratings';
import PerformanceEmployeeContainer from './employees';
import TalentReviewsContainer from './talent-reviews';

const PerformanceReviewContainer = () => {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const { networkId } = match.params as { networkId: string };
  const baseUrl = networkId ? '/networks/:id' : '/admin';
  const basePath = networkId ? `/networks/${networkId}` : '/admin';
  return (
    <Container className="tw-max-w-[calc(100%-265px)]">
      <TopNavigationBar
        title={t('performance:performance_reviews')}
        tabs={[
          {
            name: t('performance:performance_rating'),
            to: `${basePath}/performance/reports/performance-rating`,
          },
          {
            name: t('performance:performance_employee'),
            to: `${basePath}/performance/reports/employees`,
          },
          {
            name: t('performance:talent_reviews'),
            to: `${basePath}/performance/reports/talent-reviews`,
          },
        ]}
      />
      <Switch>
        <Route exact path={`${baseUrl}/performance/reports/performance-rating`}>
          <PerformanceRatingContainer />
        </Route>
        <Route exact path={`${baseUrl}/performance/reports/employees`}>
          <PerformanceEmployeeContainer />
        </Route>
        <Route exact path={`${baseUrl}/performance/reports/talent-reviews`}>
          <TalentReviewsContainer />
        </Route>
      </Switch>
    </Container>
  );
};

export default PerformanceReviewContainer;
